<template>
  <div
    :class="computedBaseClasses"
    aria-role="status"
    :aria-description="message"
   
  >
    <TIcon
      :icon="['fas', computedIcon]"
      :class="computedIconClasses"
    />
    <div>
      {{ message }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ToastVariants } from './types'

const props = withDefaults(defineProps<{
  message: string
  variant?: ToastVariants
}>(), {
  variant: 'info',
})

const computedIcon = computed(() => {
  switch (props.variant) {
    case 'success':
      return 'circle-check'
    case 'danger':
      return 'circle-exclamation'
    case 'warning':
      return 'triangle-exclamation'
    case 'info':
    default:
      return 'circle-info'
  }
})

const computedBaseClasses = computed(() => {
  return [
    'flex items-center gap-4 bg-white p-3 rounded-lg shadow-lg border border-gray-200',
  ]
})

const computedIconClasses = computed(() => {
  return [
    {
      'text-green-500': props.variant === 'success',
      'text-red-500': props.variant === 'danger',
      'text-yellow-500': props.variant === 'warning',
      'text-blue-500': props.variant === 'info',
    },
  ]
})
</script>
